<template>
  <img v-if="preferences.author.secondary_logo"
       class="secondary-company-logo"
       :class="{'whitelabel-enabled': hasWhiteLabel}"
       :src="logoSrc"
       :alt="preferences.author.name"/>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'SecondaryCompanyLogo',
  computed: {
    logoSrc () {
      return `${process.env.VUE_APP_API_DOMAIN}${this.preferences.author.secondary_logo}?token=${this.token}&t=${this.timestamp}`
    },
    hasWhiteLabel () {
      return this.$reportHS.$B.permissionsCheck.index() ||
      (!this.$reportHS.$B.permissionsCheck.index() && !this.whiteLabel)
    },
    ...mapState({
      token: state => state.report.token,
      timestamp: state => state.report.timestamp,
      whiteLabel: state => state.report.whiteLabel,
    }),
  },
}
</script>

<style lang="scss" scoped>
  .secondary-company-logo {
    position: absolute;
    top: 0;
    right: 1rem;
    max-height: 90px;

    &.square {
      max-width: 90px!important;
    }

    &.rectangle {
      max-width: 175px!important;
    }
    &.whitelabel-enabled {
      top: -60px;
      right: 0;
    }
  }
</style>
